<template>
  <v-content>
      <v-container>
        <v-card
          flat
          outlined
          color="transparent"
        >
          <v-card-title>
            Home
            <v-spacer />
            <!-- <v-btn 
              color="#4E2A84"
              outlined
              link
              to="/contact"
            >
              Free Quote
            </v-btn> -->
            <v-btn 
              style="background-color:#4E2A84;color:white"
              link
              to="/contact"
            >
              Free Quote
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text>

                BLI Tool and Die Inc. has been machining high quality parts
                since 2004. Our staff has over a century of machining
                experience incorporating traditional and revolutionary
                techniques to create precision parts for a wide array of
                industries. We take pride in providing our customers with a
                smooth process, from product inception to finished part.
                Click on the links to learn more about us or visit the
                contact page to request a quote today!
          </v-card-text>
          <v-carousel
              style="margin-left:25%;margin-right:25%;width:50%;"
              class="py-5"
          >
            <v-carousel-item
              v-for="(item,i) in carouselItems"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
        </v-card>
      </v-container>
  </v-content>
</template>

<script>


export default {
  name: 'home',
  components: {

  },
  props: [

  ],
  data () {
      return {
        carouselItems: [
          {
            src: require('../assets/home1.jpg')
          },
          {
            src: require('../assets/home2.jpg')
          },
          {
            src: require('../assets/home3.jpg')
          },
        ]
      }
    }
}
</script>

<style scoped>

</style>

<style src="../index.css"></style>